import { createContext, useContext } from 'react';

/** True when a flow renders as a desktop dialog over a background page. */
export const FlowDialogContext = createContext(false);
export const useInFlowDialog = () => useContext(FlowDialogContext);
